import { TableHead, TableRow, TableCell, TableBody } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import React from "react";

export default function MyTable({ columns, data }) {
  return <Table>
    <TableHead>
      <TableRow>
        {columns.map(x => <TableCell>{x.label}</TableCell>)}
      </TableRow>
    </TableHead>
    <TableBody>
      {data.map(_item => <TableRow>
        {columns.map(x => <TableCell>{x.options?.customBodyRender(_item[x.name]) || _item[x.name]}</TableCell>)}
      </TableRow>)
      }
    </TableBody>
  </Table>
}